/* SwiftMoto custom block: Subscriber price (product page)
   When the block's "Subscribe link" is left blank, the link points to #subscribe.
   This scrolls the shopper to the email sign-up form in the footer instead.
   If a real link is set in the theme editor, it is followed normally. */
(function () {
  if (window.swiftmotoSubscriberPriceReady) return;
  window.swiftmotoSubscriberPriceReady = true;

  var SIGNUP_SELECTORS = [
    '[id$="__omnisend-newsletter"]',
    '.omnisend-newsletter',
    '[id^="omnisend-embedded-"]',
    '.newsletter-form'
  ];

  function findSignup() {
    for (var i = 0; i < SIGNUP_SELECTORS.length; i++) {
      var element = document.querySelector(SIGNUP_SELECTORS[i]);
      if (element) return element;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-subscriber-price-subscribe]');
    if (!link || link.getAttribute('href') !== '#subscribe') return;

    var signup = findSignup();
    if (!signup) return;

    event.preventDefault();
    signup.scrollIntoView({ behavior: 'smooth', block: 'center' });

    window.setTimeout(function () {
      var input = signup.querySelector('input[type="email"], input[name*="email" i]');
      if (input) input.focus({ preventScroll: true });
    }, 700);
  });
})();
